export const PointIcon = (
  props: React.SVGAttributes<SVGSVGElement> & { color?: 'string' }
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='9'
    height='11'
    viewBox='0 0 9 11'
    fill='none'
    {...props}
  >
    <path
      d='M4.63953 10.25C4.44708 10.5833 3.96595 10.5833 3.7735 10.25L0.598077 4.75C-0.556624 2.75 0.886751 0.25 3.19615 0.25H5.21688C7.52628 0.25 8.96965 2.75 7.81495 4.75L4.63953 10.25Z'
      fill='#D83F3D'
    />
  </svg>
)
